<cx-icon [type]="iconType.EXCLAMATION_POINT"></cx-icon>
<div class="text"><ng-content></ng-content></div>
